'use client';

import { SocialLinks } from '@/components/layout/footer/footer';

export const HomeSocialSection = () => {
  return (
    <section
      className="w-full py-10 md:py-14"
      aria-labelledby="home-social-heading"
    >
      <h2
        id="home-social-heading"
        className="text-center text-2xl font-bold text-foreground md:text-left md:text-3xl mb-2"
      >
        Соцсети Марины Камбур
      </h2>
      <p className="mb-6 max-w-2xl text-center text-default-600 md:text-left md:text-lg">
        Новинки, процессы вязания и вдохновение — подписывайся, чтобы не
        пропускать обновления.
      </p>
      <div className="flex justify-center rounded-2xl border border-default-200 bg-content1/30 py-6 backdrop-blur-sm md:justify-start md:px-6 dark:bg-default-100/10">
        <SocialLinks />
      </div>
    </section>
  );
};
